let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kNFvF"), load("ffQaD"), load("kvRbA"), load("bs8Gf")]).then(() => parcelRequire('1t0Dz'));